import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { CHAT_STATUS, MessageEntity } from '..';

export const chatHelper = {
    scrollToBottom: () => {
        const ele = document.getElementsByClassName('message-display-section')[0];
        ele.scrollTop = ele.scrollHeight;
    },
    removeDuplicateMessage: (prev: MessageEntity[], messages: MessageEntity[]) => {
        if (prev.length === 0) return messages;
        const res = messages.filter((item: MessageEntity) => {
            return !prev.find((element: MessageEntity) => {
                return element.chatMessageId === item.chatMessageId;
            });
        });
        return res;
    },
    getUnreadMessage: (messages: MessageEntity[], memberId: string) => {
        return messages.filter((item: MessageEntity) => {
            return item.memberId !== memberId && item.messageStatus === CHAT_STATUS.SEND;
        });
    },
    formatSendDateTime: (date: string) => {
        if (!date) return '';
        return commonHelpers.formatDate(date, DATE_FORMAT.FORMAT_FULL);
    },
    updateChatSendingStatus: (messages: MessageEntity[], chatId: string, message: any) => {
        return messages.map((item) => {
            if (item.chatMessageId === chatId && item.messageStatus === CHAT_STATUS.SENDING) {
                return {
                    ...item,
                    ...message,
                };
            }
            return item;
        });
    },
    updateChatStatus: (messages: MessageEntity[], memberId: string) => {
        return messages.map((item) => {
            if (item.memberId === memberId && item.messageStatus !== CHAT_STATUS.NOT_SEND) {
                return {
                    ...item,
                    messageStatus: CHAT_STATUS.READ,
                };
            }
            return item;
        });
    },
};
